import React, { FC } from 'react';
import { VStack } from '@chakra-ui/react';
import EnterAmountCard from '@app/screens/liquidity/AddLiquidityV3/components/EnterAmountsCard';
import {
  useLiquidityByIchiState,
  VaultDetails
} from '@app/state/liquidityByIchiStore';
import { getCurrencyFromKimToken } from '@app/helpers/currency';
import { Mode } from '@thirdweb-dev/chains';

interface Props {
  vaultDetails: VaultDetails | null;
}

export const AmountsInput: FC<Props> = ({ vaultDetails }) => {
  const {
    amount,
    actions: { setAmount }
  } = useLiquidityByIchiState();

  if (!vaultDetails?.depositToken) {
    return null;
  }

  return (
    <>
      <VStack w="100%">
        <EnterAmountCard
          currency={getCurrencyFromKimToken(
            vaultDetails?.depositToken,
            Mode.chainId
          )}
          value={amount}
          handleChange={value => setAmount(value)}
          isDisabled={false}
        />
      </VStack>
    </>
  );
};
